import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export const useGetCitationStyles = () => {
  return useQuery({
    queryKey: ["styles"],
    queryFn: async () => {
      const res = await axios.get(`https://citation.doi.org/styles`, {
        validateStatus: (status) => status < 500,
      });

      if (res.status !== 200) {
        return [];
      }

      return res.data;
    },
  });
};

export const useGetCitationLocales = () => {
  return useQuery({
    queryKey: ["locales"],
    queryFn: async () => {
      const res = await axios.get(`https://citation.doi.org/locales`, {
        validateStatus: (status) => status < 500,
      });
      return res.data;
    },
  });
};

export const useGetCitation = (doi, style, locale) => {
  return useQuery({
    queryKey: ["citation", doi, style, locale],
    queryFn: async () => {
      if (!doi) {
        return "No doi provided";
      }
      const res = await axios.get(
        `https://citation.doi.org/format?doi=${doi}&style=${style}&lang=${locale}`,
        {
          validateStatus: (status) => status < 500,
        },
      );

      if (res.status === 404) {
        return `Citation for doi: ${doi} not found`;
      }

      if (res.status !== 200) {
        return "Error fetching citation";
      }

      return res.data;
    },
    refetchOnMount: false,
    enabled: false,
  });
};
